<template>
    <div>
        <b-button v-b-toggle.collapse-ack-status class="w-100 mb-1" variant="outline-secondary" ref="toggleAckSubmit">
            <i class="fa-solid fa-user"></i>
            {{ $t('action-items.acknowledge') }}
        </b-button>
        <b-collapse id="collapse-ack-status" class="mt-2 mb-2 w-100">
            <b-list-group-item>
                <b-form>
                    <b-form-group
                        id="input-group-ack-text"
                        :label="$t('forms.message')"
                        label-for="textarea-acknowlegde">
                        <b-form-textarea v-model="v$.acknowledgeForm.comment.$model"
                                         :class="{ 'is-invalid': v$.acknowledgeForm.$error }"
                                         id="textarea-acknowlegde"
                                         name="textarea-acknowlegde"
                                         rows="3"
                                         max-rows="6"
                                         placeholder="comment"
                        ></b-form-textarea>
                        <div class="invalid-feedback" v-if="v$.acknowledgeForm.comment.required">{{ $t('Field is required') }}
                        </div>
                    </b-form-group>
                    <b-form-group id="input-group-ack-check"
                                  :description="$t('forms.sticky-description', {obj: 'Service'})">
                        <b-form-checkbox
                            v-model="acknowledgeForm.sticky"
                            id="acknowlegde-sticky"
                            value=2
                            unchecked-value=0>
                            {{ $t('forms.sticky') }}
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group id="input-group-ack-check2"
                                  :description="$t('forms.notify-description', {obj: 'Service'})">
                        <b-form-checkbox
                            v-model="acknowledgeForm.notify"
                            id="acknowlegde-notify"
                            value=1
                            unchecked-value=0>
                            {{ $t('forms.notify') }}
                        </b-form-checkbox>
                    </b-form-group>
                    <b-button variant="success" @click="submitAcknowledgement"
                              class="w-100">{{ $t('forms.send-command') }}
                    </b-button>
                </b-form>
            </b-list-group-item>
        </b-collapse>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import {useToast} from "vue-toastification";
import { BButton } from 'bootstrap-vue-next';
export default {
    name: "Acknowledge",
    components: {BButton},
    props: [
        'uuids'
    ],
    data(){
        return {
            acknowledgeForm: {
                comment: '',
                sticky: '0',
                notify: '1'
            },
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        acknowledgeForm: {
            comment: {
                required,
            }
        }
    },
    methods: {
        async submitAcknowledgement(){
            this.v$.acknowledgeForm.$touch();
            const validated = await this.v$.acknowledgeForm.$validate();
            if(!validated){
                return;
            }
            let externalCommands = []
            if(this.uuids.length > 0){
                for(var i = 0; i < this.uuids.length; i++){
                    externalCommands.push({
                        command: 'submitServicestateAck',
                        hostUuid: this.uuids[i].hostUuid,
                        serviceUuid: this.uuids[i].serviceUuid,
                        sticky: parseInt(this.acknowledgeForm.sticky, 10),
                        notify: parseInt(this.acknowledgeForm.notify, 10),
                        author: this.$store.state.user,
                        comment: this.acknowledgeForm.comment,
                    });
                }
               // this.$refs.toggleAckSubmit.click();
                this.$emit('masscommand', externalCommands);
            }else{
                useToast().error('no services selected', {
                    timeout: 2000
                });
            }
        },
    }
}
</script>

<style scoped>

</style>
